// import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import closeIcon from "../../../assets/icons/close.svg"

// const ViewDocument = (fullpath) => {
//   const [modal, setModal] = useState(fullpath ? true : false)
//   console.log("fullpath", fullpath)

//   const toggle = () => {
//     setModal(false)
//   }

//   return (
//     <div>
//       <Modal isOpen={modal} size="md" backdrop={"static"}>
//         <ModalHeader>
//           <div className="d-flex justify-content-between">
//           <h1>View Document</h1>
//             <img
//               src={closeIcon}
//               alt=""
//               onClick={() => toggle()}
//               width="10"
//               role="button"
//             />
//           </div>
//         </ModalHeader>
//         <ModalBody>
//             <div>
//             <object width="100%" height="400" data={fullpath} type="application/pdf"></object>
//             </div>
//         </ModalBody>
//       </Modal>
//     </div>
//   )
// }
// export default ViewDocument
const ViewDocument = ({ fullpath,isView, modalClose }) => {
  console.log("fulloathefile", fullpath)

//   const handilclick = () => {
//     modalClose(false)
//   }

  return (
    <Modal isOpen={isView} size="lg" backdrop="static" toggle={modalClose}>
      <ModalHeader className="custom-modal-header">
        <div className="d-flex justify-content-between">
          <h5>View Document</h5>
          <img
            src={closeIcon}
            alt=""
            onClick={modalClose}
            width="10"
            role="button"
          />
        </div>
      </ModalHeader>
      <ModalBody>
        <div>
          <iframe src={`${process.env.REACT_APP_IMG_APIKEY}${fullpath}?embedded=true`} width="100%" height="500px" />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ViewDocument
